import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center" }
const _hoisted_2 = { class: "relative inline-flex items-center" }
const _hoisted_3 = { class: "flex flex-nowrap items-center mx-6 w-[300px]" }
const _hoisted_4 = { class: "w-4 mx-3" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "w-4 mx-3" }
const _hoisted_7 = { class: "absolute -right-[80px] flex" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "pages:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconChevronDoubleLeft = _resolveComponent("IconChevronDoubleLeft")!
  const _component_IconChevronLeft = _resolveComponent("IconChevronLeft")!
  const _component_IconDotsHorizontal = _resolveComponent("IconDotsHorizontal")!
  const _component_IconChevronRight = _resolveComponent("IconChevronRight")!
  const _component_IconChevronDoubleRight = _resolveComponent("IconChevronDoubleRight")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "bg-blue-400 p-1 text-white rounded m-2",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.moveStart && _ctx.moveStart(...args)))
      }, [
        _createVNode(_component_IconChevronDoubleLeft)
      ]),
      _createElementVNode("button", {
        class: "bg-blue-400 p-1 text-white rounded m-2",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.moveLeft && _ctx.moveLeft(...args)))
      }, [
        _createVNode(_component_IconChevronLeft)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createVNode(_component_IconDotsHorizontal, { size: "16px" }, null, 512), [
            [_vShow, !_ctx.state.pageDisplayList.find(page=> page === 1)]
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.pageDisplayList, (page, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["flex items-center justify-center rounded mx-2 hover:cursor-pointer border border-b-blue-300 min-w-7 aspect-square", page === _ctx.state.activePage ? 'bg-blue-300 text-white' : '']),
            key: index,
            onClick: ($event: any) => (_ctx.editActivePage(page))
          }, [
            _createElementVNode("p", null, _toDisplayString(page), 1)
          ], 10, _hoisted_5))
        }), 128)),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createVNode(_component_IconDotsHorizontal, { size: "16px" }, null, 512), [
            [_vShow, !_ctx.state.pageDisplayList.find(page=> page === _ctx.state.pages)]
          ])
        ])
      ]),
      _createElementVNode("button", {
        class: "bg-blue-400 p-1 text-white rounded m-2",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.moveRight && _ctx.moveRight(...args)))
      }, [
        _createVNode(_component_IconChevronRight)
      ]),
      _createElementVNode("button", {
        class: "bg-blue-400 p-1 text-white rounded m-2",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.moveEnd && _ctx.moveEnd(...args)))
      }, [
        _createVNode(_component_IconChevronDoubleRight)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("p", null, _toDisplayString(_ctx.state.pages), 1)
      ])
    ])
  ]))
}